/**
 * Single source of truth for every named debug logger in the codebase.
 *
 * Each logger flows through the `aline:` prefixed factory in `./core`, so all
 * namespaces share a common root and can be toggled together (e.g.
 * `DEBUG=aline:*`) or selectively (`DEBUG=aline:redline:*`).
 *
 * To toggle namespaces programmatically without env vars or DevTools, edit
 * `RUNTIME_OVERRIDE` in `./runtime-overrides.ts`.
 *
 * Add new loggers here rather than redeclaring `debug('...')` at call sites —
 * that keeps every available namespace visible in one place and prevents
 * silent duplicate declarations across packages.
 */
import { debug } from './core';

export const debugChat = debug('chat');
export const debugLayering = debug('redline:layering');
export const debugApply = debug('redline:apply');
export const debugApplyOps = debug('redline:apply:ops');
export const debugYjsCollab = debug('yjs:collab');
